var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDragThumbIcon = function SvgDragThumbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 25,
    rx: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 19.231,
    fill: "#707070",
    rx: 2,
    ry: 1.923
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 12.5,
    fill: "#707070",
    rx: 2,
    ry: 1.923
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 5.769,
    fill: "#707070",
    rx: 2,
    ry: 1.923
  }))));
};

export default SvgDragThumbIcon;